import { useOperationsStore } from '@operations/AppProvider'
import { EquipmentPlanningEquipmentsUIStore } from '@operations/features/equipmentPlanning/stores/equipment-planning-equipments-ui-store'
import { useTranslate } from '@tolgee/react'
import _ from 'lodash'
import { observer } from 'mobx-react-lite'
import { useNavigate } from 'react-router'
import { SelectCranes } from '../components/SelectCranes/SelectCranes'
import { CraneSplitContainerUIStore } from '../stores/crane-split-container.ui-store'
import { CraneSplitMessageUIStore } from '../stores/crane-split-message.ui-store'
import { SelectCranesDialogUIStore } from '../stores/select-cranes-dialog.ui-store'

interface Props {
  uiStore: SelectCranesDialogUIStore
  uiMessageStore: CraneSplitMessageUIStore
  uiContainerStore: CraneSplitContainerUIStore
  uiEquipmentPlanningStore: EquipmentPlanningEquipmentsUIStore
  remarks?: string
}

export const SelectCranesDialog = observer(
  ({ uiStore, uiMessageStore, uiContainerStore, uiEquipmentPlanningStore, remarks }: Props) => {
    const navigate = useNavigate()
    const { appStore } = useOperationsStore()
    const { t } = useTranslate()

    const handleClose = () => {
      if (uiStore.redirectOnCancel) {
        const url = `/vessel-visits/${uiStore.vesselId}/dashboard`

        navigate(url)
      } else {
        uiStore.toggle()
      }
    }

    const handlePlan = async (cranes: number[]) => {
      uiMessageStore.setMessage()

      await uiStore.plan(cranes)
      if (
        !_(uiContainerStore.initialCraneIds).isEqual(uiContainerStore.craneIds) &&
        uiContainerStore.initialCraneIds.length > 0
      ) {
        uiMessageStore.setMessage(
          t(
            'thereMayBeChangesToAssignedEquipmentPleaseReview',
            'There may be changes to assigned equipment. Please review to ensure everything is correct.',
          ),
          'warning',
        )
      }

      appStore.setShowAlert(
        'success',
        t('craneSplitGenerated', 'Crane split generated successfully'),
      )

      uiContainerStore.initInitialCranes()
      uiContainerStore.clearWorkQueueStack()
    }

    return (
      <SelectCranes
        selectedCranes={uiStore.selectedCranes}
        craneOptions={uiStore.cranes}
        equipmentIdsInUse={uiEquipmentPlanningStore.equipmentIdsOnUseForOtherVistis}
        berths={uiStore.vesselVisit?.berthNames ?? []}
        side={uiStore.vesselVisit?.berthSide}
        existingCraneSplitBerthSide={uiStore.vesselVisit?.craneSplitBerthSide}
        isOpen={uiStore.dialog}
        remarks={remarks}
        hasWorkInstructions={uiStore.hasWorkInstructions}
        onPlan={handlePlan}
        onClose={handleClose}
      />
    )
  },
)
